export type ProductPropertyType = "https://qmo.com/Facet/range" | "https://qmo.com/Facet/discrete"

export class ProductProperty {
    public id: string
    public name: string
    public type: ProductPropertyType
    public options: ProductPropertyOption[]

    constructor(id:string, name: string, type: ProductPropertyType, options: ProductPropertyOption[]){
        this.id = id
        this.name = name
        this.type = type
        this.options = options
    }
}

export type ProductPropertyOption = {
    id: string,
    name: string | number
}